export default function (state = false, action) {
  switch (action.type) {
    case "IS_EXPERT_IN_FACT":
      return action.payload;
      break;
    default:
      return state;
  }
}
